import React from "react";
import Button from "shared/Button";
import RadioButton from "shared/@forms/RadioButton";
import PropTypes from "prop-types";
import { Modal } from "shared/Modal";
import { SORT_METHOD } from "Marketing/CMS/enums";
import styles from "./SortModal.module.css";
import ModalActionBar from "shared/ModalActionBar";

const sortOptions = [
  SORT_METHOD.dateDesc,
  SORT_METHOD.dateAsc,
  SORT_METHOD.titleAsc,
  SORT_METHOD.titleDesc,
];

export function SortModal({ isOpen, onClose, sortBy, setSortBy }) {
  return (
    <Modal title="Sort By" isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        {sortOptions.map((name) => (
          <div key={name} className={styles.inputGroup}>
            <RadioButton
              aria-label={name}
              name="sortBy"
              value={name}
              onChange={(e) => {
                setSortBy(e.target.value);
              }}
              checked={sortBy === name}
            />
            <div className={styles.name}>{name}</div>
          </div>
        ))}

        <ModalActionBar>
          <Button onClick={onClose}>Close</Button>
        </ModalActionBar>
      </div>
    </Modal>
  );
}

SortModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  sortBy: PropTypes.string,
  setSortBy: PropTypes.func,
};
